module.exports = __webpack_public_path__ + "static/media/phone_icon.be5d9b0a.svg";